// Mock data for Sky Hostels

export const contactInfo = {
  phone: '+91 9130888003',
  email: 'skyhostels3@gmail.com',
  address: 'SKY HOSTELS, Gat No. 310, Opp. Vishwaraj Hospital, Near Kulkarni Clinic, Sky Apartment, Pune Solapur Highway, Kadamwak Wasti, Haveli Taluka, Pune 412201',
  address2: 'SKY HOSTELS, Chintamani Park, Pune Solapur Highway, Haveli Taluka, Pune 412201',
  whatsappLink: 'https://wa.me/919130888003'
};

export const heroContent = {
  title: 'Premium Boys Hostel Near Vishwaraj Hospital, Pune',
  subtitle: 'Affordable Double Sharing Rooms • 24x7 Security • High-Speed Wi-Fi',
  backgroundImage: 'https://images.unsplash.com/photo-1605848312612-bfc9e8b12d56?w=1920&q=80'
};

export const aboutContent = {
  title: 'About Sky Hostels',
  description: [
    'Premium PG hostel offering comfortable and secure living.',
    'Ideal for students and working professionals.',
    'Clean, disciplined, and well-managed environment.',
    'Hospitality-focused services with personal care.',
    'Affordable pricing with high-value facilities.'
  ],
  vision: 'To provide a home away from home with premium facilities and a supportive environment for students and professionals.',
  mission: 'Creating a safe, comfortable, and productive living space that fosters personal growth and well-being.'
};

export const roomTypes = [
  {
    id: 1,
    name: 'Single Room',
    price: 7000,
    image: 'https://images.unsplash.com/photo-1769690398892-0cd9be392d7f?w=600&q=80',
    amenities: ['Private Bathroom', 'Study Desk', 'Wardrobe', 'Wi-Fi', 'Balcony'],
    description: 'Spacious single occupancy room with all modern amenities'
  },
  {
    id: 2,
    name: '1BHK Double Sharing',
    price: 7000,
    image: 'https://images.unsplash.com/photo-1555854877-bab0e564b8d5?w=600&q=80',
    amenities: ['Shared Bathroom', '2 Study Desks', 'Wardrobes', 'Wi-Fi', 'Balcony'],
    description: 'Comfortable double sharing room ideal for students'
  }
];

export const pricingDetails = {
  hostelRent: 7000,
  foodCharges: 5000,
  deposit: 7000,
  depositNote: 'One Month (Refundable)'
};

export const inRoomFacilities = [
  { name: 'High-Speed WiFi', icon: 'Wifi' },
  { name: 'Western Bathroom', icon: 'Bath' },
  { name: 'Furnished Rooms', icon: 'Bed' },
  { name: 'Daily Housekeeping', icon: 'Sparkles' },
  { name: 'Balcony Cloth Hanger', icon: 'Wind' }
];

export const commonFacilities = [
  { name: 'Laundry', icon: 'Shirt' },
  { name: 'Study Hall', icon: 'BookOpen' },
  { name: 'Dining Hall', icon: 'UtensilsCrossed' },
  { name: 'Lift', icon: 'MoveVertical' },
  { name: 'RO Water', icon: 'Droplets' },
  { name: '24 Hrs Water', icon: 'Waves' },
  { name: 'Power Backup', icon: 'Zap' },
  { name: 'CCTV', icon: 'Camera' },
  { name: 'Security Staff', icon: 'Shield' },
  { name: 'Geyser/Solar', icon: 'Sun' },
  { name: 'Parking', icon: 'Car' }
];

export const messTimings = [
  { meal: 'Morning Tea', time: '7:30 – 8:30 AM', icon: 'Coffee' },
  { meal: 'Breakfast', time: '7:30 – 8:30 AM', icon: 'Croissant' },
  { meal: 'Lunch', time: '12:00 – 2:00 PM', icon: 'UtensilsCrossed' },
  { meal: 'Evening Tea', time: '5:00 – 5:30 PM', icon: 'Coffee' },
  { meal: 'Dinner', time: '7:00 – 8:30 PM', icon: 'Soup' }
];

export const safetyRules = [
  { title: '24x7 CCTV Surveillance', description: 'Complete premises monitored for safety', icon: 'Camera' },
  { title: 'No Smoking/Alcohol', description: 'Strictly prohibited inside premises', icon: 'Ban' },
  { title: 'Fixed Entry Timings', description: 'Entry allowed until 10:30 PM', icon: 'Clock' },
  { title: 'Silence Hours', description: '10 PM – 6 AM for better study environment', icon: 'Volume2' },
  { title: 'No Unauthorized Visitors', description: 'Visitors allowed with prior permission only', icon: 'UserX' }
];

export const admissionSteps = [
  { step: 1, title: 'Fill Admission Form', description: 'Complete the online admission form with your details' },
  { step: 2, title: 'Document Verification', description: 'Submit ID proof, college ID, and parent contact' },
  { step: 3, title: 'Pay Deposit & Rent', description: 'Pay security deposit and first month rent' },
  { step: 4, title: 'Room Allotment', description: 'Get your room assigned based on preference' },
  { step: 5, title: 'ID Card Issued', description: 'Receive your hostel ID card and access' }
];

export const testimonials = [
  {
    id: 1,
    name: 'Priya Sharma',
    role: 'Engineering Student',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&q=80',
    rating: 5,
    text: 'Sky Hostels has been a wonderful experience. The rooms are clean, staff is friendly, and the food is amazing. Feels like home!'
  },
  {
    id: 2,
    name: 'Rahul Patil',
    role: 'Working Professional',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&q=80',
    rating: 5,
    text: 'Great facilities and well-maintained hostel. The Wi-Fi speed is excellent for my work-from-home needs. Highly recommended!'
  },
  {
    id: 3,
    name: 'Sneha Kulkarni',
    role: 'Medical Student',
    image: 'https://images.unsplash.com/photo-1552334949-51934e5f2d38?w=400&q=80',
    rating: 5,
    text: 'Being close to Vishwaraj Hospital makes it perfect for me. The security and cleanliness standards are top-notch!'
  }
];

export const facilityImages = {
  studyHall: 'https://images.unsplash.com/photo-1652971422886-784758cc28d7?w=800&q=80',
  diningHall: 'https://images.unsplash.com/photo-1698844035759-099a24409d93?w=800&q=80',
  bathroom: 'https://images.unsplash.com/photo-1631889993959-41b4e9c6e3c5?w=800&q=80',
  commonArea: 'https://images.unsplash.com/photo-1615827144571-70d75560ced0?w=800&q=80'
};

// Mock booking inquiries for admin
export const mockBookings = [
  {
    id: 1,
    name: 'Amit Kumar',
    email: 'amit.k@example.com',
    phone: '+919876543210',
    roomType: 'Single Room',
    moveInDate: '2025-01-15',
    status: 'pending',
    createdAt: '2025-01-01T10:00:00Z'
  },
  {
    id: 2,
    name: 'Pooja Singh',
    email: 'pooja.s@example.com',
    phone: '+919876543211',
    roomType: '1BHK Double Sharing',
    moveInDate: '2025-01-20',
    status: 'confirmed',
    createdAt: '2025-01-02T14:30:00Z'
  }
];

// Mock contact form submissions for admin
export const mockContacts = [
  {
    id: 1,
    name: 'Vikram Desai',
    email: 'vikram.d@example.com',
    phone: '+919876543212',
    subject: 'General Inquiry',
    message: 'I would like to know more about the facilities available.',
    status: 'unread',
    createdAt: '2025-01-03T09:15:00Z'
  }
];


